import {
  Component,
  ComponentInterface,
  Element,
  h,
  Host,
  Prop,
  State,
} from '@stencil/core';

@Component({
  tag: 'signet-divider',
  styleUrl: 'signet-divider.scss',
  shadow: false,
})
export class Divider implements ComponentInterface {
  @Prop({ reflect: true }) vertical = false;

  @State() slotHasContent = false;
  @Element() elm!: HTMLElement;

  componentWillLoad() {
    this.slotHasContent = this.elm.hasChildNodes();
  }

  render() {
    return (
      <Host>
        <div
          class={{
            divider: true,
            vertical: this.vertical,
            'has-content': this.slotHasContent,
          }}
        >
          <div class="line" />
          <div class="slot-container">
            <slot />
          </div>
          <div class="line" />
        </div>
      </Host>
    );
  }
}
